import { datadogLogs } from '@datadog/browser-logs'

import { UserStore } from 'stores'

type realtimeChangeLogParams = {
  componentType: string
  dashboardId: string
}

export function dashboardComponentChangeLog({ componentType, dashboardId }: realtimeChangeLogParams) {
  const currentUserId = UserStore?.userInfo?.id

  datadogLogs.logger.info('component-change', {
    componentType,
    dashboardId,
    userId: currentUserId,
  })
}

export function getCurrentStateValueByKey(key, state, defaultFilters) {
  const currentValue = state?.[key]?.value ?? state?.[key] ?? defaultFilters?.[key]

  return currentValue
}
